import OverflowNavigationPlugin from './plugin/overflow-navigation/overflow-navigation.plugin';
import LottiePlayerPlugin from './plugin/lottie-player/lottie-player.plugin';
import FeatureAccordionsPlugin from './plugin/feature-accordions/feature-accordions.plugin';
import Alpine from 'alpinejs';
import { registerCompare } from './plugin/compare/compare';
import { registerDesktopNav } from './plugin/desktop-nav/desktop-nav';
window.Alpine = Alpine;
const pluginManager = window.PluginManager;
pluginManager.register('KroneProductConfigurator', () => import('./product-configurator/product-configurator.plugin'), '[id="krone-product-configurator"]');
pluginManager.register('KroneProductAccessories', () => import('./product-accessories/product-accessories.plugin'), '[id="krone-product-accessories"]');
pluginManager.register('KroneProductDebugPlugin', () => import('./product-debug/product-debug.plugin'), '[id="krone-product-debug"]');
pluginManager.extend('ProductSlider', 'ProductSlider', () => import('./plugin/extended-plugins/extended-product-slider-plugin/extended-product-slider-plugin.plugin'), '[data-product-slider]');
pluginManager.extend('CollapseFooterColumns', 'CollapseFooterColumns', () => import('./plugin/extended-plugins/extended-footer-columns-collapse-plugin/extended-footer-columns-collapse-plugin.plugin'), '[data-collapse-footer-columns]');
pluginManager.extend('AccountMenu', 'AccountMenu', () => import('./plugin/extended-plugins/extended-account-menu-plugin/extended-account-menu.plugin'), '[data-account-menu]');
pluginManager.extend('ZoomModal', 'ZoomModal', () => import('./plugin/extended-plugins/extended-zoom-modal-plugin/extended-zoom-modal.plugin'), '[data-zoom-modal]');
pluginManager.extend('OffCanvasMenu', 'OffCanvasMenu', () => import('./plugin/extended-plugins/extended-offcanvas-menu-plugin/extended-offcanvas-menu.plugin'), '[data-off-canvas-menu]');
/**
 * Product media download/share (PDP)
 */
pluginManager.register('KroneProductDocumentDownload', () => import('./plugin/document-download/document-download.plugin'), '[id="krone-product-document-download"]');
pluginManager.register('KroneProductDocumentSharePlugin', () => import('./plugin/product-document-share/product-document-share.plugin'), '[id="krone-product-document-download"]');
pluginManager.register('CopyToClipboardPlugin', () => import('./plugin/copy-to-clipboard/copy-to-clipboard.plugin'), '[data-copy-to-clipboard]');
pluginManager.register('OverflowNavigationPlugin', OverflowNavigationPlugin, '[data-overflow-navigation-wrap]');
pluginManager.register('LottiePlayerPlugin', LottiePlayerPlugin, 'lottie-player');
pluginManager.register('FeatureAccordionsPlugin', FeatureAccordionsPlugin, '[data-feature-accordions]');
/**
 * Checkout/Cart Share link generator
 */
pluginManager.register('KroneCartShare', () => import('./plugin/cart-share/cart-share.plugin'), '[data-krone-cart-share]');
/**
 * Cart product media share link generator
 */
pluginManager.register('KroneCartMediaShare', () => import('./plugin/cart-media-share/cart-media-share.plugin'), '[data-krone-cart-media-share]');
/**
 * Checkout/Confirm custom data handling
 */
pluginManager.register('KroneCartData', () => import('./plugin/cart-data/cart-data.plugin'), '[id="confirmOrderForm"]');
pluginManager.register('ShippingPrivateCustomerPlugin', () => import('./plugin/shipping-private-customer/shipping-private-customer.plugin'), '[data-shipping-private-customer-toggle]');
pluginManager.register('MaskedLinkPlugin', () => import('./plugin/masked-link/masked-link.plugin'), '[data-masked-url]');
/**
 * Tooltips
 */
pluginManager.register('TooltipPlugin', () => import('./plugin/tooltip/tooltip.plugin'), '[data-toggle="tooltip"]');
/**
 * Form access request
 */
pluginManager.register('FormAccessRequest', () => import('./plugin/form-access-request/form-access-request.plugin'), '[data-form-access-request]');
/**
 * Stock notification form and addToCart handler
 */
pluginManager.register('KroneStockNotificationPlugin', () => import('./plugin/stock-notification/krone-stock-notification.plugin'), '#submitNotifyAndAddToCart');
pluginManager.register('ModelViewerTogglePlugin', () => import('./plugin/model-viewer-toggle/model-viewer-toggle.plugin'), '[data-model-viewer]');
pluginManager.register('CaseStudyLightbox', () => import('./plugin/case-study-lightbox/case-study-lightbox.plugin'), '[data-case-study-lightbox]');
registerCompare();
registerDesktopNav();
Alpine.start();
